module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Logged in as","logOut":"Log out"},"no":{"title":"Logget inn som","logOut":"Logg ut"}}')
  delete Component.options._Ctor
}
